// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  defaultAdb2cTemplate: 'business',
  myInvitationBaseUrl: "/my-invitation",
  registerBaseUrl: "/register",
  rootDomain: 'skeddle.com',
  defaultTenant: 'business',

  appInsights: {
    instrumentationKey: "04fd5df0-9dbd-459b-8968-c910b3bcbb76",
    applicationName: 'skeddle-business'
  },
  sentryDsn: "https://8a025ee07588c0258935bc9068d32c59@o4508941675855873.ingest.de.sentry.io/4508942902165584",
  domainHint: null
};

/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {LogLevel, Configuration, BrowserCacheLocation} from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
      clientId: '5dfb2516-2d94-480d-845d-4dea80bda275', // This is the ONLY mandatory field that you need to supply.
      authority: 'https://skeddleexternal.ciamlogin.com/', // Replace the placeholder with your tenant subdomain
      // authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
      redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
      postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        // console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    scopes: ["api://cccde33a-00a7-4100-a096-15cb02287a9f/access_as_user"]
}
